export enum SettlementType {
    Instant = 'INSTANT',
    Cycle = 'CYCLE',
    OnDemand = 'ON_DEMAND'
}

export enum FeePayerType {
    CUSTOMER = 'CUSTOMER',
    BUSINESS = 'BUSINESS',
}

export interface GatewaySettlementSettings {
    gatewayId: string;
    rialiSettlementType?: SettlementType | null;
    rialiCycleFixedFee?: number | null;
    rialiCyclePercentageFee?: number | null;
    rialiCycleFeeCap?: number | null;
    rialiInstantFixedFee?: number | null;
    rialiInstantPercentageFee?: number | null;
    rialiInstantFeeCap?: number | null;
    rialiTransactionFeeCap?: number | null;
    rialiCycleSettlementTime?: string | null;
    rialiFeePayerType?: FeePayerType | null;
    isRialiSettlementEnabled: boolean;
    usdtSettlementType?: SettlementType | null;
    usdtCycleFixedFee?: number | null;
    usdtCyclePercentageFee?: number | null;
    usdtInstantFixedFee?: number | null;
    usdtInstantPercentageFee?: number | null;
    usdtMinimumSettlement?: number | null;
    usdtFeePayerType?: FeePayerType | null;
    isUsdtSettlementEnabled: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface UpdateGatewaySettlementSettingsPayload {
    gatewayId: string;
    data: Omit<GatewaySettlementSettings, 'gatewayId' | 'createdAt' | 'updatedAt'>;
}